<template>
  <div
    :class="classList"
    class="c-questionnaire-item"
    @click="onClick"
  >
    <d-icon v-if="icon" :icon="icon" class="c-questionnaire-item__icon"/>
    <c-checkbox
      v-else-if="checkbox"
      :icon="icon"
      :minimum="true"
      :name="name"
      :value="selected"
      class="c-questionnaire-item__checkbox"
    />
    <c-radio
      v-else
      :icon="icon"
      :minimum="true"
      :name="name"
      :value="selected"
      :value-default="value"
      class="c-questionnaire-item__radio"
    />
    <div class="c-questionnaire-item__text" v-html="text"/>
    <d-ripple/>
  </div>
</template>

<script>
import CCheckbox from './CCheckbox'
import DIcon from 'dcode/components/DIcon'
import CRadio from './CRadio'
import DRipple from 'dcode/components/DRipple'
import { computed } from 'vue'

export default {
  name: 'CQuestionnaireItem',
  components: {
    CCheckbox,
    DIcon,
    CRadio,
    DRipple
  },
  emits: ['on-click'],
  props: {
    // Values
    icon: String,
    name: String,
    text: String,
    value: String,
    only: Boolean,

    // Status
    selected: Boolean,

    // Options
    checkbox: Boolean
  },
  setup (props, context) {
    return {
      classList: computed(() => {
        return {
          'value-icon': props.icon,
          'status-selected': props.selected
        }
      }),

      onClick () {
        context.emit('on-click', {
          value: props.value,
          only: props.only,
          selected: !props.selected
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "~dcode/styles/color";
@import "~dcode/styles/flex";
@import "~dcode/styles/margin";
@import "~dcode/styles/media";
@import "~dcode/styles/padding";
@import "~dcode/styles/position";

.c-questionnaire-item {
  $this: &;

  --_qi-palette-type1: var(--qi-palette-type1, var(--palette-type1, var(--primary-type1)));
  --_qi-padding: var(--qi-padding, 8px);
  --_qi-icon: var(--qi-icon, 48px);
  --_qi-icon-ds: var(--qi-icon-ds, 64px);

  --_qi-overlay: var(--background-overlay);

  --ic-radius: 0;
  --rp-palette: var(--_qi-overlay);

  display: flex;
  padding: var(--_qi-padding);
  transition-property: background;
  align-items: flex-start;

  @include afterAbsolute() {
    border-width: 1px;
    transition-property: border;
  }

  &__checkbox,
  &__radio {
    padding-top: calc(var(--_qi-padding) / 4);
    padding-bottom: calc(var(--_qi-padding) / 4);
  }

  &__icon + &__text,
  &__checkbox + &__text,
  &__radio + &__text {
    @include marginDirectionLeft(var(--_qi-padding));
  }

  &__icon {
    --ic-size: var(--_qi-icon);
    --ic-font: calc(var(--_qi-icon) - var(--_qi-padding));

    @include marginY(var(--_qi-padding));
    @include marginDirectionLeft(var(--_qi-padding));
    transition-property: background, color;
  }

  &__text {
    @include paddingY(var(--_qi-padding));
    padding-right: 8px;
  }

  &:hover {
    background-image: varColor(--_qi-overlay, --opacity-container-focus-light, true);
  }

  &.status-selected {
    --_qi-overlay: var(--_qi-palette-type1);
    background-color: varColor(--_qi-palette-type1, --opacity-container-selected-light);

    &::after {
      border-color: varColor(--_qi-palette-type1);
      border-width: 2px;
    }

    #{$this}__icon {
      --basic-text: var(--_qi-palette-type1);
    }
  }

  &.value-icon {
    align-items: center;

    @include mediaMinWidth(large) {
      flex-flow: column;
      padding-left: 16px;
      padding-right: 16px;

      #{$this}__text {
        text-align: center;
      }

      #{$this}__icon {
        --_qi-icon: var(--_qi-icon-ds);

        @include marginX(0);
        margin-bottom: 0;

        & + #{$this}__text {
          @include marginDirectionLeft(0px);
        }
      }
    }
  }
}
</style>
